/**
 * @member {String|null} address
 * @member {String|null} director_name
 * @member {String|null} email
 * @member {String|null} fiz_address
 * @member {String|null} inn
 * @member {Boolean} innControlSumErr
 * @member {String|TypeaheadOrganization} innData
 * @member {Boolean} innError
 * @member {String|null} innHint
 * @member {String|null} name
 * @member {Number|null} nationality_id
 * @member {Boolean} need_attorney
 * @member {String|null} ownerDirectorName
 * @member {String|null} ownerPositionOfManager
 * @member {String|null} phone
 * @member {String|null} position_of_manager
 * @member {String|null} subject_id
 * @member {String|null} website
 */
export default class OrganizationDto {
  address
  director_name
  email
  // fiz_address
  inn
  innControlSumErr
  innData
  innError
  innHint
  name
  nationality_id
  need_attorney
  ownerDirectorName
  ownerPositionOfManager
  phone
  position_of_manager
  subject_id
  website

  /**
   * @param {String|null} address
   * @param {String|null} director_name
   * @param {String|null} email
   * @param {String|null} fiz_address
   * @param {String|null} inn
   * @param {Boolean} innControlSumErr
   * @param {String|TypeaheadOrganization} innData
   * @param {Boolean} innError
   * @param {String|null} innHint
   * @param {String|null} name
   * @param {Number|null} nationality_id
   * @param {Boolean} need_attorney
   * @param {String|null} ownerDirectorName
   * @param {String|null} ownerPositionOfManager
   * @param {String|null} phone
   * @param {String|null} position_of_manager
   * @param {String|null} subject_id
   * @param {String|null} website
   */
  constructor({
    address,
    director_name,
    email,
    // fiz_address,
    inn,
    innControlSumErr,
    innData,
    innError,
    innHint,
    name,
    short_name,
    nationality_id,
    need_attorney,
    ownerDirectorName,
    ownerPositionOfManager,
    phone,
    position_of_manager,
    subject_id,
    website
  }) {
    const properties = {
      configurable: false,
      enumerable: true,
      writable: false
    }

    if (![undefined, null].includes(address)) {
      address = String(address)
    }
    if (![undefined, null].includes(director_name)) {
      director_name = String(director_name)
    }
    if (![undefined, null].includes(email)) {
      email = String(email)
    }
    // if (![undefined, null].includes(fiz_address)) {
    //   fiz_address = String(fiz_address)
    // }
    if (![undefined, null].includes(inn)) {
      inn = String(inn)
    }
    innControlSumErr = Boolean(innControlSumErr ?? false)
    // TODO add handling of innData field, which could be in current version both String and TypeaheadOrganization
    innError = Boolean(innError ?? false)
    if (![undefined, null].includes(innHint)) {
      innHint = String(innHint)
    }
    if (![undefined, null].includes(name)) {
      name = String(name)
    }
    if (![undefined, null].includes(short_name)) {
      short_name = String(short_name)
    }
    if (![undefined, null].includes(nationality_id)) {
      nationality_id = Number(nationality_id)
    }
    need_attorney = Boolean(need_attorney)
    if (![undefined, null].includes(ownerDirectorName)) {
      ownerDirectorName = String(ownerDirectorName)
    }
    if (![undefined, null].includes(ownerPositionOfManager)) {
      ownerPositionOfManager = String(ownerPositionOfManager)
    }
    if (![undefined, null].includes(phone)) {
      phone = String(phone)
    }
    if (![undefined, null].includes(position_of_manager)) {
      position_of_manager = String(position_of_manager)
    }
    if (![undefined, null].includes(subject_id)) {
      subject_id = String(subject_id)
    }
    if (![undefined, null].includes(website)) {
      website = String(website)
    }

    Object.defineProperty(this, 'address', Object.assign({ value: address }, properties))
    Object.defineProperty(this, 'director_name', Object.assign({ value: director_name }, properties))
    Object.defineProperty(this, 'email', Object.assign({ value: email }, properties))
    // Object.defineProperty(this, 'fiz_address', Object.assign({ value: fiz_address }, properties))
    Object.defineProperty(this, 'inn', Object.assign({ value: inn }, properties))
    Object.defineProperty(this, 'innControlSumErr', Object.assign({ value: innControlSumErr }, properties))
    Object.defineProperty(this, 'innData', Object.assign({ value: innData }, properties))
    Object.defineProperty(this, 'innError', Object.assign({ value: innError }, properties))
    Object.defineProperty(this, 'innHint', Object.assign({ value: innHint }, properties))
    Object.defineProperty(this, 'name', Object.assign({ value: name }, properties))
    Object.defineProperty(this, 'short_name', Object.assign({ value: short_name }, properties))
    Object.defineProperty(this, 'nationality_id', Object.assign({ value: nationality_id }, properties))
    Object.defineProperty(this, 'need_attorney', Object.assign({ value: need_attorney }, properties))
    Object.defineProperty(this, 'ownerDirectorName', Object.assign({ value: ownerDirectorName }, properties))
    Object.defineProperty(this, 'ownerPositionOfManager', Object.assign({ value: ownerPositionOfManager }, properties))
    Object.defineProperty(this, 'phone', Object.assign({ value: phone }, properties))
    Object.defineProperty(this, 'position_of_manager', Object.assign({ value: position_of_manager }, properties))
    Object.defineProperty(this, 'subject_id', Object.assign({ value: subject_id }, properties))
    Object.defineProperty(this, 'website', Object.assign({ value: website }, properties))

    Object.freeze(this)
  }
}
